import Vue from '@/main'
import { dateFormat } from '@/utils/dateUtil.js'
import { capitalizeFirstLetter } from '@/utils/stringUtil.js'
import { getUserDateFormat } from '@/utils/dateUtil.js'

const chartVisualizationTypes = {
  months: 0,
  weeks: 1,
  days: 2,
}

const lastRangedDataProperties = {
  lastRangedValue: 5,
  lastRangedType: chartVisualizationTypes.days,
}

const countDateTimeFormatMonth = 'MMMM'

// Esse método é um workaround para substituir o formato das datas de acordo com a configuração do usuário, para melhorá-lo a lógica de configuração também deve ser melhorada
const getUserDayFormat = () => {
  const regexDayFormat = /(dd\/mm|mm\/dd)/
  const userDateTimeFormat = getUserDateFormat(Vue.$store.state.auth.user.dateTimeFormat)
  
  const dayFormat = userDateTimeFormat.match(regexDayFormat);

  return dayFormat ? dayFormat : 'dd/MM';
}

const getLastRangedData = (chartData) => {
  return chartData.slice(-lastRangedDataProperties.lastRangedValue)
}

const getCountDateTimeFormat = (chartVisualization) => {
  if (chartVisualization === chartVisualizationTypes.months) return countDateTimeFormatMonth
  if (chartVisualization === chartVisualizationTypes.weeks) return getUserDayFormat()
  if (chartVisualization === chartVisualizationTypes.days) return getUserDayFormat()
}

const getChartData = (chartData) => {
  const lastRangedData = getLastRangedData(chartData)

  const datasetData = lastRangedData.map((data) => data.count)

  const labelsData = lastRangedData.map((data) => data.label)

  return { datasetData, labelsData }
}

const getGroupedDataKey = (countDateTime, chartVisualization) => {
  const countDateTimeFormat = getCountDateTimeFormat(chartVisualization)

  //#region Em português os meses retornam com a inicial minúscula, o código abaixo é um workaround para este caso exclusivamente
  const formattedCountDatetime = countDateTime.toFormat(countDateTimeFormat)
  const capitalizedCountDatetime = capitalizeFirstLetter(formattedCountDatetime)
  //#endregion

  if (chartVisualization !== chartVisualizationTypes.weeks) return capitalizedCountDatetime

  const startOfWeek = countDateTime.startOf('week').toFormat(countDateTimeFormat)
  const endOfWeek = countDateTime.endOf('week').toFormat(countDateTimeFormat)
  const rangeText = Vue.$t('home.blockAudience.graph.rangeAux')

  return `${startOfWeek} ${rangeText} ${endOfWeek}`
}

const getGroupedLabel = (countDateTime, groupedDataKey, chartVisualization) => {
  if (chartVisualization == chartVisualizationTypes.weeks) return groupedDataKey

  if (chartVisualization == chartVisualizationTypes.days) {
    const primaryLabelFormatted = countDateTime.toFormat('ccc')
    const capitalizedPrimaryLabel = capitalizeFirstLetter(primaryLabelFormatted)

    return [capitalizedPrimaryLabel, groupedDataKey]
  }
  if (chartVisualization == chartVisualizationTypes.months) {
    const secondaryLabelFormatted = countDateTime.toFormat('yyyy')

    return [groupedDataKey, secondaryLabelFormatted]
  }
  return groupedDataKey
}

const getGroupedDataByVisualization = (chartData, chartVisualization) => {
  const groupedData = {}

  const chartDataSortedByCountDatetimeASC = chartData.sort((a, b) => dateFormat(a.countDateTime) - dateFormat(b.countDateTime))
  for (const item of chartDataSortedByCountDatetimeASC) {
    const countDateTime = dateFormat(item.countDateTime)

    const groupedDataKey = getGroupedDataKey(countDateTime, chartVisualization)

    if (!groupedData[groupedDataKey]) {
      groupedData[groupedDataKey] = {
        countDateTimes: [countDateTime],
        count: item.count,
        label: getGroupedLabel(countDateTime, groupedDataKey, chartVisualization),
      }
    } else {
      groupedData[groupedDataKey].countDateTimes.push(countDateTime)
      groupedData[groupedDataKey].count = item.count
    }
  }

  return Object.values(groupedData)
}

const getGroupedChartData = (chartData, chartVisualization) => {
  switch (chartVisualization) {
    case chartVisualizationTypes.months: {
      const chartDataGroupedByMonth = getGroupedDataByVisualization(chartData, chartVisualizationTypes.months)

      const { datasetData, labelsData } = getChartData(chartDataGroupedByMonth)
      return { datasetData, labelsData }
    }
    case chartVisualizationTypes.weeks: {
      const chartDataGroupedByWeek = getGroupedDataByVisualization(chartData, chartVisualizationTypes.weeks)

      const { datasetData, labelsData } = getChartData(chartDataGroupedByWeek)
      return { datasetData, labelsData }
    }
    case chartVisualizationTypes.days: {
      const chartDataGroupedByDay = getGroupedDataByVisualization(chartData, chartVisualizationTypes.days)

      const { datasetData, labelsData } = getChartData(chartDataGroupedByDay)
      return { datasetData, labelsData }
    }
  }
}

export { chartVisualizationTypes, getGroupedChartData }
